<template>
  <div class="welcome">
    <img class="img" src="@/assets/welcome.png" alt="" />
    <div
      class="readeyApplyTxt"
      v-if="status === 6 || status === 7"
    >
      <i class="el-icon-warning" style="color: #dc1e32"></i>
        <span v-if="status === 6">欢迎登录顺丰运力货主系统，为了不影响您的正常使用，请前往完成实名认证。<span @click="toPersonalAuthentication" class="sign_btn">去实名认证</span></span>
        <span v-if="status === 7">欢迎登录顺丰运力货主系统，为了不影响您的正常使用，请前往完成企业认证。<span @click="toEnterpriseInformation" class="sign_btn">去企业认证</span></span>
    </div>
    <el-dialog
      title="安全提示！"
      :visible.sync="dialogVisible"
      width="22%"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <span class="des"
        >您的账号可能存在安全风险，为了保障您的账户安全，请修改初始密码。</span
      >
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="toLogin">退出登录</el-button>
        <el-button size="mini" type="danger" @click="changePassword"
          >修改密码</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="安全提示！"
      :visible.sync="validTimeVisible"
      width="22%"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <span class="des"
        >您的密码已过有效期，为了保障您的账户安全，请修改密码或申请密码延期。</span
      >
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="passwordExtend">密码延期</el-button>
        <el-button size="mini" type="danger" @click="changePassword"
          >修改密码</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="安全提示！"
      :visible.sync="validTimeExtend"
      width="22%"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <span>密码延期成功！当前密码有效期：{{ extendTime }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="danger" @click="validTimeExtend = false"
          >知道了</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      dialogVisible: false,
      validTimeVisible: false,
      validTimeExtend: false,
      extendTime: "",
      accounts: "",
      phone: "",
      // isRegFlag: false,
    };
  },
  created() {
    // this.isRegFlag = this.$route.query.isRegFlag;
    if (this.$route.query.code == "2") {
      this.dialogVisible = true;
    } else if (this.$route.query.code == "1") {
      this.validTimeVisible = true;
    }
    let phone = localStorage.getItem("accounts");
    if (phone) {
      this.accounts = phone.split(",");
      this.phone = this.accounts[this.accounts.length - 1];
    }
  },
  // watch: {
  //   status: {
  //     handler(val) {
  //       console.log(val);
  //       if (val === 0 || val === 1 || val === 3) {
  //         this.isRegFlag = true;
  //       } else {
  //         this.isRegFlag = false;
  //       }
  //     },
  //     immediate: true,
  //   },
  // },
  computed: {
    ...mapGetters(["status"]),
  },
  mounted() {},
  methods: {
    ...mapActions([
      "getMenu",
      "getStatus",
      "logoutApi",
      "firstLandingReset",
      "delayValidTm",
      "queryByCustomerNoAPI",
    ]),
    toLogin() {
      this.logoutApi().then(() => {
        this.$message({
          type: "success",
          message: "退出成功!",
        });
        setTimeout(() => {
          this.dialogVisible = false;
          this.$router.push("/");
        }, 300);
      });
      //   this.$confirm("你确定要退出吗?", "退出提示", {
      //     confirmButtonText: "确定",
      //     cancelButtonText: "取消",
      //     type: "warning",
      //   })
      //     .then(() => {
      //       this.logoutApi().then(() => {
      //         this.$message({
      //           type: "success",
      //           message: "退出成功!",
      //         });
      //         setTimeout(() => {
      //           this.$router.push("/");
      //         }, 300);
      //       });
      //     })
      //     .catch(() => {
      //       this.dialogVisible = true;
      //     });
    },
    passwordExtend() {
      let params = {
        userId: this.$store.state.login.userId,
        telephone: this.phone,
      };
      this.delayValidTm(params).then((res) => {
        if (res) {
          this.extendTime = res;
          this.$message.success("操作成功");
        }
      });
      this.validTimeVisible = false;
      this.validTimeExtend = true;
    },
    changePassword() {
      this.$router.push("/changePassword");
      this.dialogVisible = false;
      this.validTimeVisible = false;
    },
    toPersonalAuthentication(){
      this.$router.push("/manage/personalAuthentication");
    },
    toEnterpriseInformation() {
      this.$router.push("/manage/enterpriseCertification");
    },
  },
};
</script>
<style lang="css" scoped>
.welcome {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-content: center;
  justify-content: center;
}
.img {
  width: 100%;
  height: 100%;
}
.readeyApplyTxt {
  width: 95%;
  position: absolute;
  top: 30px;
  /* left: 30px; */
  padding: 10px !important;
  /* font-size: 14px; */
  background: rgba(220, 30, 50, 0.08);
  border: 1px solid rgba(220, 30, 50, 0.5);
  border-radius: 4px;
}
.des {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
}
.sign_btn {
  float: right;
  color: #DC1E32;
  cursor: pointer;
}
</style>